module.exports = __webpack_public_path__ + "img/newsImg5-1.a2ce2d15.png";